module.exports = __webpack_public_path__ + "@/assets/img/003-girl-1.78592824.svg";